import { useState, useEffect } from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";

import getPromotions from "../services/getPromotions.service";

export default function usePromotions() {
  const [promotions, setPromotions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const {
    i18n: { language },
  } = useTranslation();

  const fetchPromotions = async () => {
    setIsLoading(true);
    try {
      const promotions = await getPromotions({ locale: language });
      setPromotions(promotions);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPromotions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  return { promotions, isLoading };
}
